import React, { useLayoutEffect, useRef } from 'react';

import { useTranslation } from '../../utils/utils';
import { classNames } from '../../utils/style';
import {
  textBody,
  textBodyUppercase,
  textBodyUppercaseSmall,
} from '../../styles/typography';

import { translate } from './translate';

export interface FileDescriptionBlockProps {
  className?: string;
  editDate: Date;
  format: string;
  writer: {
    genre: 'woman' | 'man';
    name: string;
  };
}

export const FileDescriptionBlock = ({
  className,
  editDate,
  format,
  writer,
}: FileDescriptionBlockProps) => {
  const container = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (!container) return;

    listener();
    window.addEventListener('resize', listener);

    return () => {
      window.removeEventListener('resize', listener);
    };

    // hide-unhide separator responsively
    function listener() {
      const containerBlock = container.current;
      const block0: HTMLElement | null | undefined =
        containerBlock?.querySelector('.block-0');
      const block1: HTMLElement | null | undefined =
        containerBlock?.querySelector('.block-1');
      const block2: HTMLElement | null | undefined =
        containerBlock?.querySelector('.block-2');

      if (containerBlock?.offsetWidth && containerBlock.offsetWidth <= 506) {
        if (block1) block1.style.borderColor = 'transparent';
        if (block2) block2.style.marginTop = '17px';
      } else {
        if (block1) block1.style.borderColor = '';
        if (block2) block2.style.marginTop = '';
      }

      if (containerBlock?.offsetWidth && containerBlock.offsetWidth <= 325) {
        if (block0) block0.style.borderColor = 'transparent';
        if (block1) block1.style.marginTop = '17px';
      } else {
        if (block0) block0.style.borderColor = '';
        if (block1) block1.style.marginTop = '';
      }
    }
  }, [container]);

  return (
    <div
      className={classNames(
        'FileDescriptionBlock',
        className,
        'flex flex-wrap items-center',
        'justify-center w-full p-12',
        'bg-neutral-1 rounded-18',
      )}
      ref={container}
    >
      <div className="flex flex-col items-center border-r border-neutral-51  my-[34px] px-[34px] block-0 gap-y-8">
        <h6 className={textBodyUppercaseSmall}>
          {useTranslation(translate.format)}
        </h6>
        <div className={classNames(textBodyUppercase, 'text-blue-101')}>
          {format}
        </div>
      </div>
      <div
        className={classNames(
          'flex flex-col items-center',
          'border-r border-neutral-51',
          'my-[34px] px-[34px] block block-1 gap-y-8',
        )}
      >
        <h6 className={textBodyUppercaseSmall}>
          {useTranslation(translate.date)}
        </h6>
        <div className={classNames(textBody, 'text-blue-101')}>
          {editDate.toLocaleDateString()}
        </div>
      </div>
      <div className="flex flex-col items-center my-[34px] px-[34px] block-2 gap-y-8">
        <h6 className={textBodyUppercaseSmall}>
          {useTranslation(translate?.[`writer${writer.genre}`])}
        </h6>
        <div className={classNames(textBody, 'text-blue-101')}>
          {writer.name}
        </div>
      </div>
    </div>
  );
};
